import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from '../model/track-action-result';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';
import { MaritalStatusInvestActionV2 } from '../cadastro-investidor-v2/actions/marital-status-v2-action';

export class UpdateMaritalTrack extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('marital-status', ['marital-status', 'marital-status'], undefined, {
      undefined,
      actionName: ActionList.ActionMarital
    }),
    new TrackInfo('spouse', ['marital-status', 'spouse']),
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.updateRegistration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {dataOrigin: DomainOrigin[environment.updateRegistration]})
  ];

  track = [];

  constructor() {
    super();
    this.track = this.originalTracks;
  }


  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.UPDATE_REGISTRATION;
  }

  async loadData() {
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    return MaritalStatusInvestActionV2.execute(data, this.track);
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionMarital = 'actionMarital'
}
